export const BUCKET_PREFIX = import.meta.env.VITE_S3_BUCKET_PREFIX;
const isProduction = import.meta.env.PROD;
export const ENVIRONMENT = isProduction ? 'production' : 'development';

export const getImageUrlWithBucketPrefix = (imageUrl: string) => {
  const isStartingWithSlash = imageUrl?.startsWith('/');
  if (imageUrl && imageUrl.indexOf('https://') === -1) {
    return `${BUCKET_PREFIX}${isStartingWithSlash ? '' : '/'}${imageUrl}`;
  }
  return imageUrl;
};
